import _extends from '@babel/runtime/helpers/esm/extends';
import 'core-js/modules/es6.array.map.js';
import React__default from 'react';
import { Divider } from '../dropdown-menu-divider.js';
import { Heading } from '../dropdown-menu-heading.js';
import { DropdownMenuCheckboxItem, StyledDropdownMenuRadioGroup, DropdownMenuRadioItem } from '../dropdown-menu-input-item.js';
import { DropdownMenuItem, DropdownMenuCustomItem } from '../dropdown-menu-item.js';
import { SubMenu } from '../dropdown-sub-menu.js';
import { Text } from '../../text/text.js';

var dropdownMenuItemToComponentMap = function dropdownMenuItemToComponentMap(createDropdownMenuItems) {
  return {
    default: function _default(props) {
      var _ref = props,
          text = _ref.text,
          innerProps = _ref.props,
          beforeText = _ref.beforeText;
      var innerText = beforeText ? /*#__PURE__*/React__default.createElement("span", {
        style: {
          display: "inline-flex",
          gap: "0.25rem",
          alignItems: "center",
          maxWidth: "100%"
        }
      }, /*#__PURE__*/React__default.createElement("span", {
        style: {
          flexShrink: 0
        }
      }, beforeText), /*#__PURE__*/React__default.createElement(Text, {
        ellipsize: true
      }, text)) : text;
      return /*#__PURE__*/React__default.createElement(DropdownMenuItem, _extends({}, innerProps, {
        text: innerText
      }));
    },
    checkbox: function checkbox(props) {
      var _ref2 = props,
          text = _ref2.text,
          innerProps = _ref2.props;
      return /*#__PURE__*/React__default.createElement(DropdownMenuCheckboxItem, _extends({}, innerProps, {
        textValue: text
      }));
    },
    divider: function divider(props) {
      var _ref3 = props,
          innerProps = _ref3.props;
      return /*#__PURE__*/React__default.createElement(Divider, innerProps);
    },
    heading: function heading(props) {
      var _ref4 = props,
          text = _ref4.text,
          innerProps = _ref4.props;
      return /*#__PURE__*/React__default.createElement(Heading, innerProps, text);
    },
    submenu: function submenu(props) {
      var _ref5 = props,
          items = _ref5.items,
          innerProps = _ref5.props;
      return /*#__PURE__*/React__default.createElement(SubMenu, innerProps, createDropdownMenuItems(items));
    },
    radio: function radio(props) {
      var _ref6 = props,
          items = _ref6.items,
          innerProps = _ref6.props;
      return /*#__PURE__*/React__default.createElement(StyledDropdownMenuRadioGroup, innerProps, items.map(function (item) {
        return /*#__PURE__*/React__default.createElement(DropdownMenuRadioItem, _extends({}, item.props, {
          key: item.key,
          textValue: item.text
        }));
      }));
    },
    custom: function custom(props) {
      var _ref7 = props,
          innerProps = _ref7.props;
      return /*#__PURE__*/React__default.createElement(DropdownMenuCustomItem, innerProps);
    }
  };
};

export { dropdownMenuItemToComponentMap };
//# sourceMappingURL=dropdown-menu-item-component-map.js.map
